/* ============================================================
   SAVRAA \u2014 delivery timeline  v6

   Dates are fully dynamic. Nothing is hardcoded:
     Purchased  = the real current date, read at page load
     Processing = Purchased +2 to +3 days
     Delivered  = Purchased +5 to +6 days

   Runs on EVERY product page. The injector targets
   main[data-template="product"], and Liquid's template.name returns
   "product" for alternate templates too (product.car-charger,
   product.urea-cream, etc), so custom templates need no setup.

   ------------------------------------------------------------
   v6 FIX (2026-08-13) \u2014 THE DATES WERE INVISIBLE

   The connector carried BOTH flex:0 1 auto AND width:100%. A
   flex-basis of auto resolves to the width property, so each of the
   two connectors claimed 100% of the row:

     total basis = 0 + 100% + 0 + 100% + 0 = 200%

   Shrinkage is distributed by (shrink-factor x basis). The steps had
   basis 0, so they absorbed none of it \u2014 the connectors took all the
   shrink and still ended up owning the entire row, leaving every step
   at 0px wide.

   The date span has overflow:hidden, so it was clipped to nothing.
   The label span had no overflow rule, so it overflowed and stayed
   visible. That asymmetry is why icons and labels rendered while the
   dates silently vanished.

   Fix \u2014 size the row the way it was always meant to be sized:
     step      flex:0 1 auto  -> width comes from its own text
     connector flex:1 1 20px  -> soaks up whatever is left over
   Text now decides the layout and the lines fill the gaps. On a narrow
   phone the steps still shrink (min-width:0) and ellipsis, so the row
   can never overflow the viewport.
   ------------------------------------------------------------

   v5: "now" resolved in the store timezone (Asia/Riyadh), not the
       shopper's device. Midnight rollover refresh on tab return.
   v4: calendar days, not business days. With the KSA weekend (Fri+Sat)
       a "5-6 day" promise counted in business days rendered as ~10
       calendar days. Set USE_BUSINESS_DAYS = true to restore.

   LAYOUT OWNERSHIP: this file owns layout (flex, width, overflow).
   assets/savraa-delivery-timeline.css owns colour and shape only.
   Do not add layout rules to the stylesheet \u2014 that is what broke v3.

   NOTE: these dates are a promise shown before payment. If real
   fulfilment is slower, widen the constants rather than leave them
   optimistic \u2014 a missed date is the biggest driver of COD refusal.
   ============================================================ */
(function () {
  var LABELS = { ordered: 'Purchased', packed: 'Processing', delivered: 'Delivered' };

  /* ---- tune the promise here ---- */
  var STORE_TZ = 'Asia/Riyadh';  // where the orders are actually fulfilled
  var CUTOFF_HOUR = 14;          // orders after 14:00 store time start counting tomorrow
  var READY_MIN_DAYS = 2;
  var READY_MAX_DAYS = 3;
  var DELIVERED_MIN_DAYS = 5;
  var DELIVERED_MAX_DAYS = 6;
  var USE_BUSINESS_DAYS = false; // true = skip Fri/Sat when counting
  var WEEKEND_DAYS = [5, 6];     // Fri, Sat (KSA)

  // Current date/time as it is at the warehouse, not on the shopper's phone.
  function storeNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: STORE_TZ,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hour12: false
      }).formatToParts(new Date());

      var v = {};
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].type !== 'literal') v[parts[i].type] = parseInt(parts[i].value, 10);
      }
      if (v.year == null || v.month == null || v.day == null) return new Date();

      var hour = v.hour == null ? 0 : v.hour;
      if (hour === 24) hour = 0;  // some engines emit 24 for midnight under hour12:false

      return new Date(v.year, v.month - 1, v.day, hour, v.minute || 0, 0, 0);
    } catch (e) {
      return new Date();          // no Intl timezone support \u2014 use device time
    }
  }

  function isWeekend(d) {
    return WEEKEND_DAYS.indexOf(d.getDay()) !== -1;
  }

  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var remaining = days;
    while (remaining > 0) {
      d.setDate(d.getDate() + 1);
      if (!isWeekend(d)) remaining -= 1;
    }
    return d;
  }

  function addCalendarDays(date, days) {
    var d = new Date(date.getTime());
    d.setDate(d.getDate() + days);
    return d;
  }

  function addDays(date, days) {
    return USE_BUSINESS_DAYS ? addBusinessDays(date, days) : addCalendarDays(date, days);
  }

  function fmt(date) {
    return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' }).format(date);
  }

  function fmtRange(a, b) {
    var as = fmt(a), bs = fmt(b);
    if (as === bs) return as;
    if (a.getMonth() !== b.getMonth()) return as + ' \u2013 ' + bs;
    var day = new Intl.DateTimeFormat('en-US', { day: 'numeric' }).format(b);
    return as + ' \u2013 ' + day;
  }

  // Recomputed on every call, so a tab left open overnight refreshes correctly.
  function computeTimeline() {
    var now = storeNow();
    var origin = now.getHours() >= CUTOFF_HOUR ? addDays(now, 1) : now;
    return {
      orderedDate: now,
      readyMin: addDays(origin, READY_MIN_DAYS),
      readyMax: addDays(origin, READY_MAX_DAYS),
      deliveredMin: addDays(origin, DELIVERED_MIN_DAYS),
      deliveredMax: addDays(origin, DELIVERED_MAX_DAYS)
    };
  }

  var ICONS = {
    bag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 8h15l-1.2 12.2a1.6 1.6 0 0 1-1.6 1.4H7.3a1.6 1.6 0 0 1-1.6-1.4z"/><path d="M8.6 8V6.2a3.4 3.4 0 0 1 6.8 0V8"/></svg>',
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M1.6 6.4h12.2v10H1.6z"/><path d="M13.8 10h4.1l3.5 3.2v3.2h-7.6z"/><circle cx="6.4" cy="18.4" r="2"/><circle cx="17.4" cy="18.4" r="2"/></svg>',
    pin: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21.5s7-6.1 7-11.2a7 7 0 1 0-14 0c0 5.1 7 11.2 7 11.2z"/><circle cx="12" cy="10.1" r="2.6"/></svg>'
  };

  function buildTimelineEl() {
    var tl = computeTimeline();

    var wrap = document.createElement('div');
    wrap.className = 'savraa-delivery-timeline';
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('dir', 'ltr');
    wrap.setAttribute('lang', 'en');
    wrap.setAttribute('aria-label', 'Purchased, processing and delivered dates');
    wrap.setAttribute('data-savraa-timeline', 'true');
    wrap.style.cssText = [
      'display:flex',
      'align-items:flex-start',
      'gap:0',
      'direction:ltr',
      'margin:1.2rem 0',
      'padding:1.3rem 1.4rem',
      'border-radius:12px',
      'width:100%',
      'max-width:100%',
      'overflow:hidden',
      'box-sizing:border-box'
    ].join(';') + ';';

    var steps = [
      { icon: 'bag',   date: fmt(tl.orderedDate),                        label: LABELS.ordered,   align: 'flex-start' },
      { icon: 'truck', date: fmtRange(tl.readyMin, tl.readyMax),         label: LABELS.packed,    align: 'center' },
      { icon: 'pin',   date: fmtRange(tl.deliveredMin, tl.deliveredMax), label: LABELS.delivered, align: 'flex-end' }
    ];

    steps.forEach(function (step, i) {
      var stepEl = document.createElement('div');
      stepEl.className = 'savraa-delivery-timeline__step';
      // flex:0 1 auto => the step is as wide as its own text and can still
      // shrink. min-width:0 lets it shrink below its content on tiny screens
      // so the ellipsis can do its job instead of overflowing the viewport.
      stepEl.style.cssText = [
        'display:flex',
        'flex-direction:column',
        'align-items:' + step.align,
        'text-align:' + (step.align === 'center' ? 'center' : (step.align === 'flex-end' ? 'right' : 'left')),
        'flex:0 1 auto',
        'min-width:0'
      ].join(';') + ';';

      stepEl.innerHTML =
        '<span class="savraa-delivery-timeline__icon" style="display:flex;align-items:center;justify-content:center;width:24px;height:24px;margin-bottom:9px;flex:none;">' +
          ICONS[step.icon] +
        '</span>' +
        '<span class="savraa-delivery-timeline__date" style="font-size:1.2rem;font-weight:700;line-height:1.25;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:100%;">' +
          step.date +
        '</span>' +
        '<span class="savraa-delivery-timeline__label" style="font-size:1.1rem;font-weight:400;margin-top:2px;line-height:1.25;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:100%;">' +
          step.label +
        '</span>';

      var svg = stepEl.querySelector('svg');
      if (svg) { svg.setAttribute('width', '22'); svg.setAttribute('height', '22'); }

      wrap.appendChild(stepEl);

      if (i < steps.length - 1) {
        var conn = document.createElement('span');
        conn.className = 'savraa-delivery-timeline__line';
        conn.setAttribute('aria-hidden', 'true');
        // flex:1 1 20px => the connector takes the leftover room after the
        // text has been laid out, and gives it back first when space is tight.
        // NEVER set width:100% here: flex-basis:auto would resolve to it and
        // the connectors would swallow the whole row (the v3-v5 bug).
        conn.style.cssText = [
          'flex:1 1 20px',
          'display:flex',
          'align-items:center',
          'margin:11px 6px 0',
          'min-width:14px'
        ].join(';') + ';';
        conn.innerHTML =
          '<span style="width:4px;height:4px;border-radius:50%;flex:none;"></span>' +
          '<span style="flex:1 1 auto;height:1.5px;min-width:8px;"></span>' +
          '<span style="width:4px;height:4px;border-radius:50%;flex:none;"></span>';
        wrap.appendChild(conn);
      }
    });

    return wrap;
  }

  function isVisible(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function findAnchor(main) {
    var codButton = main.querySelector('.savraa-cod-button');
    if (codButton && isVisible(codButton)) return codButton;
    var group = main.querySelector('.savraa-buy-buttons-group');
    if (group && isVisible(group)) return group;
    if (codButton) return codButton;
    if (group) return group;
    return (
      main.querySelector('.product-form__buttons') ||
      main.querySelector('form[action*="/cart/add"]') ||
      main.querySelector('product-form')
    );
  }

  function ensureTimeline() {
    try {
      var main = document.querySelector('main[data-template="product"]');
      if (!main) return;
      var anchor = findAnchor(main);
      if (!anchor || !anchor.parentNode) return;

      var existing = main.querySelector('.savraa-delivery-timeline');
      if (existing) {
        if (existing.previousElementSibling === anchor) return;
        existing.remove();
      }

      anchor.parentNode.insertBefore(buildTimelineEl(), anchor.nextSibling);
    } catch (e) {
      /* fail silently, retries will keep trying */
    }
  }

  var scheduled = false;
  function scheduleEnsure() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      ensureTimeline();
    });
  }

  // A tab left open past midnight would otherwise keep showing yesterday's
  // dates. Rebuild when the shopper returns to the tab on a new day.
  var builtOnDay = null;
  function refreshIfDayChanged() {
    var today = storeNow().toDateString();
    if (builtOnDay && builtOnDay !== today) {
      var existing = document.querySelector('.savraa-delivery-timeline');
      if (existing) existing.remove();
    }
    builtOnDay = today;
    ensureTimeline();
  }

  function boot() {
    var main = document.querySelector('main[data-template="product"]');
    if (!main) return;
    builtOnDay = storeNow().toDateString();
    ensureTimeline();
    new MutationObserver(scheduleEnsure).observe(main, { childList: true, subtree: true });
    [200, 600, 1200, 2500, 4000].forEach(function (delay) {
      setTimeout(ensureTimeline, delay);
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') refreshIfDayChanged();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', ensureTimeline);
})();
